export interface RegistrationLenderStatus {
  ApplicationID: string;
  LenderID: string;
  Status: RegistrationStatus;
  Tier: number;
  Broker: number;
}

export enum RegistrationStatus {
  RegistrationStatusUnknown = '',
  RegistrationStatusAutoRegistration = 'registration',
  RegistrationStatusReRegistration = 're-registration',
  RegistrationStatusCompleted = 'completed',
}
